// dito ASK — Regel-Engine (identische Semantik zu src/Survey/RuleEngine.php; Fixtures tests/fixtures/rules/*.json).
export function evaluateRule(rule, answers, questions) {
  if (rule.all) return rule.all.every(r => evaluateRule(r, answers, questions));
  if (rule.any) return rule.any.some(r => evaluateRule(r, answers, questions));
  const q = String(rule.q ?? ''); const op = String(rule.op ?? '');
  let answer = answers[q] ?? null;
  let question = questions[q];
  if (rule.row !== undefined && answer && typeof answer === 'object' && Array.isArray(answer.ranking)) {
    // Sprint 7b: Rangfolge – Platz des Elements als Zahl; nicht platziert = unbeantwortet
    const pos = answer.ranking.map(String).indexOf(String(rule.row));
    answer = pos < 0 ? null : { number: pos + 1 };
  } else if (rule.row !== undefined && answer && typeof answer === 'object') answer = (answer.rows && answer.rows[String(rule.row)]) || null;
  if (rule.col !== undefined) {
    // Sprint 7a: Zelle einer mehrspaltigen Matrix – Auswertungswerte aus den Optionen der Spalte
    answer = answer && typeof answer === 'object' && answer.cols ? (answer.cols[String(rule.col)] || null) : null;
    const c = question && Array.isArray(question.columns) ? question.columns.find(x => String(x.column_key) === String(rule.col)) : null;
    question = c ? { question_type: 'matrix_single', options: c.options || [], rows: [] } : undefined;
  }
  const value = scalar(answer);
  const selected = answer && Array.isArray(answer.options) ? answer.options.map(String) : (value !== null && answer && answer.option !== undefined ? [String(answer.option)] : []);
  const answered = value !== null || selected.length > 0;
  switch (op) {
    case 'answered': return answered;
    case 'not_answered': return !answered;
    case 'eq': return answered && (selected.length ? selected.includes(String(rule.v)) && selected.length === 1 : cmp(value, rule.v) === 0);
    case 'neq': return !answered || (selected.length ? !selected.includes(String(rule.v)) : cmp(value, rule.v) !== 0);
    case 'in': { const list = (Array.isArray(rule.v) ? rule.v : [rule.v]).map(String); const mine = selected.length ? selected : [String(value)]; return answered && mine.some(x => list.includes(x)); }
    case 'contains': return selected.includes(String(rule.v ?? ''));
    case 'gt': case 'gte': case 'lt': case 'lte': {
      const num = numeric(answer, question);
      if (num === null || rule.v === undefined) return false;
      const c = cmp(num, rule.v);
      return op === 'gt' ? c > 0 : op === 'gte' ? c >= 0 : op === 'lt' ? c < 0 : c <= 0;
    }
  }
  return false;
}
function scalar(a) {
  if (!a || typeof a !== 'object') return null;
  if (a.option !== undefined && a.option !== '' && a.option !== null) return String(a.option);
  if (Array.isArray(a.options) && a.options.length) return 'multi';
  if (Array.isArray(a.ranking) && a.ranking.length) return 'ranking';
  if (a.number !== undefined && a.number !== '' && a.number !== null) return Number(a.number);
  if (a.date) return String(a.date);
  if (a.text && String(a.text).trim() !== '') return String(a.text);
  return null;
}
function numeric(a, question) {
  if (!a || typeof a !== 'object') return null;
  if (a.number !== undefined && a.number !== '' && a.number !== null) return Number(a.number);
  if (a.date) return String(a.date);
  if (a.option !== undefined && question) { const o = (question.options || []).find(o => String(o.option_key) === String(a.option)); return o && o.numeric_value !== null && o.numeric_value !== undefined ? Number(o.numeric_value) : null; }
  return null;
}
function cmp(a, b) {
  const na = typeof a === 'number' ? a : (a !== '' && !isNaN(Number(a)) ? Number(a) : null);
  const nb = typeof b === 'number' ? b : (b !== '' && !isNaN(Number(b)) ? Number(b) : null);
  if (na !== null && nb !== null) return na < nb ? -1 : na > nb ? 1 : 0;
  const sa = String(a), sb = String(b);
  return sa < sb ? -1 : sa > sb ? 1 : 0;
}
